module.exports = __webpack_public_path__ + "static/media/333.6b354ea0.svg";